<template>
  <section class="space-y-2 p-4">
    <viewTitle title="业务管理 / 报表管理 / 供应商评估表" :showReturn="true">
      <template slot="return">
        <el-button v-has="['c-mpReport-record-unitExport']" @click="onExport" type="primary" size="small">导出</el-button>
      </template>
    </viewTitle>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="基地">
        <el-select class="w-40" clearable v-model="queryParam.base_id">
          <el-option
            v-for="item in com_list"
            :key="item.com_id"
            :label="item.com_name"
            :value="item.com_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="木片厂名称">
        <el-input
          clearable
          v-model="queryParam.chip_name"
          placeholder="请输入木片厂名称"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="供应商">
        <el-input
          clearable
          v-model="queryParam.supplier_name"
          placeholder="请输入供应商名称"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="省">
        <el-input
          clearable
          v-model="queryParam.province"
          placeholder="请输入省"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="市">
        <el-input
          clearable
          v-model="queryParam.city"
          placeholder="请输入市"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="县">
        <el-input
          clearable
          v-model="queryParam.district"
          placeholder="请输入县"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="refreshData" type="primary" size="small"
          >刷新数据</el-button
        >
        <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table
      class="mt-4"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="id"
      @loadPage="loadData"
    >
    </c-table>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
export default {
  data() {
    return {
      columns: [
        { label: "基地", prop: "company_name" },
        { label: "供应商", prop: "supplier_name" },
        { label: "供应商性质", prop: "supplier_nature" },
        { label: "木片厂名", prop: "chip_name" },
        { label: "木片厂性质", prop: "chip_type" },
        { label: "木片厂状态", prop: "chip_state" },
        { width: 120, label: "日供货能力（车/天）", prop: "daily_supply_num" },
        { label: "省", prop: "province" },
        { label: "市", prop: "city" },
        { label: "县", prop: "district" },
        { label: "最晚发货日期", prop: "last_deliver_day" },
        { label: "最近7天日均发货数量", prop: "supply_num_7" },
        { label: "近一个月发货日均数量", prop: "supply_num_30" },
      ],
      exportDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/unit_assess_report_export",
          data: params,
          noLoading: true
        })
      },
      fetchDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/unit_assess_report_list",
          data: params
        });
      },
    };
  },
  mixins: [initListMinxin]
};
</script>
<style lang="less" scoped></style>
